/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Represents the state of a participant in a session.
 */ 
export enum ParticipantState {
    Unknown = 0,
    Registered = 1,
    CheckedIn = 2,
    Aborted = 3,
    Absent = 4,
    Excused = 5,
}
